export enum EFilterKeys {
  AnimalName = 'Animal name',
  AnimalType = 'Animal type',
  AnimalBreed = 'Animal breed',
  PropertyName = 'Property name',
  AnimalColors = 'Animal colors',
  ApplicationType = 'Application type',
  VaccinationExpiration = 'Rabies vaccination expiration',
}
